// The interest blocklist (docs/lead-relay.md §5.2). A LEAF — no imports.
//
// ⚠️⚠️ WHY THESE TWO, so nobody re-enables them: choosing "Finance Enquiry" on
// the dealer's form sends the customer's details to EV Direct Finance, and
// "Novated Lease Enquiry" sends them to OLY. A Meta lead has agreed to neither —
// they filled in a Facebook form, not the dealer's. These options are not
// missing by oversight; they are blocked on purpose.
//
// If a dealer asks for them, that is a CONSENT conversation with the client,
// not a config change. It lives in code (not on the route) precisely so that
// nobody editing a route in the CRM can switch it back on.

export const BLOCKED_INTERESTS: readonly string[] = ['Finance Enquiry', 'Novated Lease Enquiry'];

function fold(value: string): string {
  return value.trim().replace(/\s+/g, ' ').toLowerCase();
}

const BLOCKED_FOLDED = new Set(BLOCKED_INTERESTS.map(fold));

/** Case-insensitive, whitespace-tolerant: " finance  ENQUIRY " is blocked. */
export function isBlockedInterest(value: string): boolean {
  return BLOCKED_FOLDED.has(fold(value));
}
